export enum DataSourceSettingsTabType {
  GENERAL = 'general',
  PROXY = 'proxy',
  SHARING = 'sharing',
  FIELD_PRESETS = 'field-presets',
  DATA_IMPORT = 'data-import',
  FIELD_MAPPING = 'field-mapping',
  PARTNER_MAPPING = 'partner-mapping',
  PRODUCT_MAPPING = 'product-mapping',
}
